import moment from "moment";
import { getReadingFrequency } from "../../util/reading-frequency";

const DAY = 86400000;

// the ranges a chart may open on, shortest first, and how many days each reaches back
const OPENING_RANGES = [['24_hours', 1], ['7_days', 7], ['30_days', 30], ['three_months', 92]];

/**
 * The range a sensor's chart opens on: the shortest that will show readings.
 * One that reads every few minutes opens on the last 24 hours; one that
 * reads once a day and uploads every two days (battery saver), or one that
 * has been quiet a while, opens wide enough to reach its last reading and
 * two before it -- and to hold three readings at the least.
 */
export const defaultRangeFor = (sensor, now = Date.now()) => {

  const { readingSecs } = getReadingFrequency(sensor);
  const step = (readingSecs || 0) * 1000;
  const last = sensor && sensor.last_checkin ? window.datetimeToDate(sensor.last_checkin) : null;
  const since = last && isFinite(last.getTime()) ? Math.max(0, now - last.getTime()) : 0;
  const need = Math.max(since + 2 * step, 3 * step);
  const fits = OPENING_RANGES.find(([, days]) => need <= days * DAY);

  return fits ? fits[0] : OPENING_RANGES[OPENING_RANGES.length - 1][0];

};

const dateRange = (defaultDateRange="24_hours") => {

  return `
  <div class="dashboard-active-sensor__settings__option">
    <label>
      Date Range:
      <select name="readings_date_range" class="dashboard-active-sensor__readings-date-range">
        <option value="24_hours" ${defaultDateRange === '24_hours' ? 'selected' : ''}>Last 24 Hours</option>
        <option value="today" ${defaultDateRange === 'today' ? 'selected' : ''}>Today</option>
        <option value="6_hours" ${defaultDateRange === '6_hours' ? 'selected' : ''}>Last 6 Hours</option>
        <option value="12_hours" ${defaultDateRange === '12_hours' ? 'selected' : ''}>Last 12 Hours</option>
        <option value="yesterday" ${defaultDateRange === 'yesterday' ? 'selected' : ''}>Yesterday</option>
        <option value="this_week" ${defaultDateRange === 'this_week' ? 'selected' : ''}>This Week (Sun - Today)</option>
        <option value="7_days" ${defaultDateRange === '7_days' ? 'selected' : ''}>Last 7 Days</option>
        <option value="last_week" ${defaultDateRange === 'last_week' ? 'selected' : ''}>Last Week (Sun - Sat)</option>
        <option value="this_month" ${defaultDateRange === 'this_month' ? 'selected' : ''}>This Month</option>
        <option value="30_days" ${defaultDateRange === '30_days' ? 'selected' : ''}>Last 30 Days</option>
        <option value="last_month" ${defaultDateRange === 'last_month' ? 'selected' : ''}>Last Month</option>
        <option value="three_months" ${defaultDateRange === 'three_months' ? 'selected' : ''}>Last Three Months</option>
        <option value="custom" ${defaultDateRange === 'custom' ? 'selected' : ''}>Custom</option>
      </select>
    </label>   
  </div>
  
  <div class="dashboard-active-sensor__readings-date-range__custom">
    <div class="dashboard-active-sensor__readings-date-range__custom__start">
      <label for="custom-date-range-start">Start Date</label>
      <input type="text" id="custom-date-range-start" class="custom-date-range-start" value="${moment().format('MM/DD/YYYY')}" /> 
    </div>
    <div class="dashboard-active-sensor__readings-date-range__custom__end">
      <label for="custom-date-range-end">End Date</label>
      <input type="text" id="custom-date-range-end" class="custom-date-range-end" value="${moment().format('MM/DD/YYYY')}" /> 
    </div>
    <div class="dashboard-active-sensor__readings-date-range__custom__button">
      <button class="button button--medium">Apply</button>
    </div>
    <div class="dashboard-active-sensor__readings-date-range__custom__error">This is an error</div>
    
  </div>
  `
}

export default dateRange;
